
import { Options, prop, Vue } from "vue-class-component";
import Accordion from "@/app/ui/components/accordion/index.vue";
import { flags } from "@/feature-flags";
import { SttAdjustmentRule } from "@/domain/entities/ShipmentBooking";
import { ConfigValidationForm } from "@/domain/entities/CreateBookingV3";
import UploadImageTiny from "../upload-image-tiny/index.vue";
import { UploadMultiple } from "@/domain/entities/MainApp";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { BookingController } from "@/app/ui/controllers/BookingController";
import { DeleteHydraFileRequest, UploadHydraFileRequest } from "@/data/payload/api/BookingRequest";
import { parsingErrorResponse } from "@/app/infrastructures/misc/Utils";

class Props {
  modelValue = prop<any>({
    required: true,
  });
  showViewAdjustment = prop<any>({
    default: false,
    type: Boolean,
  });
  defaultOpened = prop<any>({
    default: true,
    type: Boolean,
  });
  title = prop<string>({
    default: "",
    type: String,
  });
  watermark = prop<string>({
    default: "",
    type: String,
  });
  configPiece = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  marginBottom = prop<boolean>({
    default: true,
    type: Boolean
  });
  isMandatoryUploadProofAdjust = prop<boolean>({
    default: false,
    type: Boolean
  });
}
@Options({
  emits: ["onUploadImage", "onDeleteImage", "update:showViewAdjustment"],
  components: {
    Accordion,
    UploadImageTiny
  },
})
class AdjustWeightSection extends Vue.with(Props) {
  isShaking = false;
  proofPhotos = [{}, {}];
  attachmentImage: any = ["", ""];

  get getRulePieceDisabled() {
    return this.configPiece.rule.includes(ConfigValidationForm.NON_EDITABLE);
  }

  get maxPhoto() {
    return flags.flag_max_photo_for_weight_adjustment.getValue();
  }
  onAddImage() {
    this.proofPhotos.push({ source: "", desc: "" });
    this.$emit("update:modelValue", this.attachmentImage);
  }

  async onUpload(file: any) {
    if (!file.file) return;
    try {
      const uploadedUrl = await this.uploadImageToHydra(file);
      this.attachmentImage[file.index] = uploadedUrl;
    } catch (_error) {
      this.attachmentImage[file.index] = "";
    }
    this.$emit("update:modelValue", this.attachmentImage);
  }

  async uploadImageToHydra(uploadData: UploadMultiple): Promise<string> {
    MainAppController.showLoading();
    try {
      const response = await BookingController.uploadHydraFile(
        new UploadHydraFileRequest({
          attachFile: uploadData.file,
          folderPath: "/stt"
        })
      );
      if (typeof response.data !== "string" || !response.data) {
        throw new Error("Empty supporting document URL");
      }
      return response.data;
    } finally {
      MainAppController.closeLoading();
    }
  }

  async onRemove(index: number) {
    MainAppController.showLoading();
    try {
      await BookingController.deleteHydraFile(
        new DeleteHydraFileRequest({
          attachFiles: [this.attachmentImage[index]]
        })
      );
      this.deleteFiles(index);
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(err, "Gagal menghapus Foto ke storage!")
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  deleteFiles(index: number) {
    this.attachmentImage[index] = "";
    this.$emit("update:modelValue", this.attachmentImage);
  }

  onClick(value: any) {
    this.$emit("update:showViewAdjustment", value);
  }

  photoDescription(index: number) {
    if (index === 0) {
      return this.$t(
        "bookingV4.shipment.additionalWeight.weightPhoto"
      ) as string;
    } else if (index === 1) {
      return this.$t(
        "bookingV4.shipment.additionalWeight.photoWithIdentity"
      ) as string;
    } else {
      return this.$t(
        "bookingV4.shipment.additionalWeight.additionalPhoto"
      ) as string;
    }
  }

  get photoGuides() {
    return [
      { source: "guide-photo-one", desc: this.photoDescription(0) },
      { source: "guide-photo-two", desc: this.photoDescription(1) }
    ];
  }
}
export default AdjustWeightSection;
